<template>
  <el-dialog
    width="400px"
    custom-class="reset-route-dialog"
    class="reset-route-dialog-container"
    :visible="visible"
    :append-to-body="false"
    :modal="false"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    :show-close="false"
  >
    <div slot="title" class="header">
      <div class="header-left">
        <svg-icon name="ic-warning" class="warning-icon" />
        <span class="title">Applied Fuel Plan will be reset</span>
      </div>
       <svg-icon name="close" class="ic-close" @click.native="handleCancel" />
    </div>
    <div class="content">
      Changing of stops will reset the applied fuel plan.
    </div>
    <div slot="footer" class="footer">
      <common-button size="small" @click="handleCancel">CANCEL</common-button>
      <common-button type="danger" size="small" @click="handleSubmit">PROCEED</common-button>
    </div>
  </el-dialog>
</template>
<script>
export default {
}
</script>
<style lang="scss">
.reset-route-dialog-container {
  background: rgba(0, 0, 0, 0.325);
}
.reset-route-dialog {
  display: flex;
  flex-direction: column;
  margin: 0 !important;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translateX(-50%) translateY(-50%);
  max-height: calc(100% - 30px);
  max-width: calc(100% - 30px);
  box-shadow: 0 2px 10px 0 rgba(70, 83, 106, 0.2);
  border-radius: 4px;
  .el-dialog__header {
    padding: 24px 24px 4px !important;
    .header {
      display: flex;
      align-items: center;
      justify-content: space-between;
      .header-left {
        display: flex;
        align-items: center;
        .warning-icon {
          font-size: 24px;
          flex-shrink: 0;
        }
        .title {
          margin-left: 8px;
          font-family: 'Open Sans';
          font-style: normal;
          font-weight: 700;
          font-size: 16px;
          line-height: 24px;
          color: #000000;
        }
      }
      .ic-close {
        flex-shrink: 0;
        font-size: 24px;
        color: #4C556C;
        cursor: pointer;
      }
    }
  }
  .el-dialog__body {
    padding: 0 !important;
    word-break: normal !important;
    flex: 1;
    margin-right: 4px;
    padding: 0 52px 0 56px !important;
    overflow: scroll;
    overflow: overlay;
    &::-webkit-scrollbar {
      display: block;
      width: 4px;
      height: 0;
    }
    &::-webkit-scrollbar-thumb {
      width: 4px;
      height: 0;
      border-radius: 4px;
      background-color: #dadce1;
      &:hover {
        background-color: rgba(0, 0, 0, 0.5);
      }
    }
    .content {
      font-family: 'Open Sans';
      font-style: normal;
      font-weight: 500;
      font-size: 12px;
      line-height: 16px;
      color: #7F8596;
    }
  }
  .el-dialog__footer {
    padding: 20xp 24px 24px !important;
    display: flex;
    align-items: center;
    justify-content: flex-end;
    .common-button:nth-of-type(2) {
      margin-left: 16px;
    }
  }
}
</style>
